import React, {useEffect, useState} from 'react';

import styles from './UserList.module.less';
import {Button, Space, Table, Tag} from "antd";
import {ColumnsType} from "antd/es/table";
import AdminService from "./Admin.service";
import {User} from '../../interfaces';

const columns: ColumnsType<User> = [
  {
    title: 'UID',
    dataIndex: 'userId',
    key: 'userId',
    render: text => <span>{text}</span>,
  },
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: '注册时间',
    dataIndex: 'registrationDate',
    key: 'registrationDate',
  },
  {
    title: '角色',
    key: 'role',
    dataIndex: 'role',
    render: (_, { role }) => (
      <>
        {[role].map(r => {
          let color = r.length > 5 ? 'geekblue' : 'green';
          if (r === 'SUPER_ADMIN') {
            color = 'volcano';
          }
          return (
            <Tag color={color} key={r}>
              {r.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: '操作',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <a>授权</a>
        <a>修改密码</a>
      </Space>
    ),
  },
];

interface UserListProps {
  temp: string
}

function UserList(props: UserListProps) {
  const {temp} = props;
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    AdminService.getUsers()
      .then(res => {
        setUsers(res.data);
      });
  }, []);

  return (
    <div className={styles.root}>
      <Button disabled>新增用户</Button>
      <Table
        columns={columns}
        dataSource={users}
      />
    </div>
  )
}

export default UserList;
